export default __webpack_public_path__ + "static/media/signFormLogo.91c85c6c.png";